// import React from 'react';
// import { Bar, Doughnut } from 'react-chartjs-2';
// import Chart from 'chart.js/auto';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './App.css'; // 確保這個CSS文件存在並且包含你需要的樣式

// Chart.register(ChartDataLabels);


// const CombinedCharts = () => {
//   const barChartData = {
//     labels: ['聽', '說', '讀', '寫'],
//     datasets: [
//       {
//         label: '程度',
//         backgroundColor: 'rgba(75,192,192,0.4)',
//         borderColor: 'rgba(75,192,192,1)',
//         borderWidth: 1,
//         hoverBackgroundColor: 'rgba(75,192,192,0.6)',
//         hoverBorderColor: 'rgba(75,192,192,1)',
//         data: [0, 1, 2, 1],
//       },
//     ],
//   };

//   const barChartOptions = {
//     plugins: {
//       datalabels: {
//         display: true,
//         color: 'black',
//         align: 'end',
//         anchor: 'end',
//         formatter: (value) => {
//           const labels = ['無', 'B1', 'B2'];
//           return labels[value];
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           stepSize: 1,
//           max: 2,
//           callback: function (value) {
//             const labels = ['無', 'B1', 'B2'];
//             return labels[value];
//           },
//         },
//       },
//     },
//   };

//   const doughnutData = {
//     labels: ["音樂", "公民", "幼保", "美術", "物理", "地科", "生物", "國文"],
//     datasets: [
//       {
//         label: 'Color Distribution',
//         backgroundColor: [
//           '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FFCD56', '#C9CBCF'
//         ],
//         hoverBackgroundColor: [
//           '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FFCD56', '#C9CBCF'
//         ],
//         data: [300, 50, 100, 200, 150, 120, 180, 90],
//       },
//     ],
//   };

//   const doughnutOptions = {
//     plugins: {
//       datalabels: {
//         display: true,
//         color: 'white',
//         formatter: (value, context) => {
//           const label = context.chart.data.labels[context.dataIndex];
//           return `${label}: ${value}`;
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//       <div style={{ width: '45%', textAlign: 'left' }}>
//         <br></br>
//         <h2>能力統計</h2>
//         <Bar data={barChartData} options={barChartOptions} />
//       </div>

//       <div style={{ width: '45%', textAlign: 'left' }}>
//         <br></br>
//         <h2>任教科目分佈</h2>
//         <Doughnut data={doughnutData} options={doughnutOptions} />
//       </div>
//     </div>
//   );
// };

// export default CombinedCharts;

import React, { useState, useEffect } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import axios from 'axios';

const CombinedCharts = () => {
  const [BarChartData, setBarChartData] = useState({
    labels: ['聽', '說', '讀', '寫'],
    datasets: [
      {
        label: '程度',
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75,192,192,0.6)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: [],
      },
    ],
  });

  useEffect(() => {
    // Fetch data from backend
    axios.get('/cramSchool/api/student') // Replace with your actual API endpoint
      .then(response => {
        const studentData = response.data;
        if (studentData.length > 0) {
          const student = studentData[0]; // Assuming you're using the first student for the chart
          const data = [
            mapLevelToValue(student.phone_home),
            mapLevelToValue(student.speaking),
            mapLevelToValue(student.reading),
            mapLevelToValue(student.address)
          ];
          setBarChartData(prevState => ({
            ...prevState,
            datasets: [
              {
                ...prevState.datasets[0],
                data: data
              }
            ]
          }));
        }
      })
      .catch(error => {
        console.error('Error fetching student data:', error);
      });
  }, []);

  const mapLevelToValue = (level) => {
    const levels = {
      '無': 0,
      'B1': 1,
      'B2': 2
    };
    return levels[level] !== undefined ? levels[level] : 0;
  };

  const barChartOptions = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value, index, values) {
            const labels = ['無', 'B1', 'B2'];
            return labels[value];
          },
          stepSize: 1,
          max: 2, // 設定最大值為2以適應刻度
        },
      },
    },
  };

  const DoughnutData = {
    labels: ["音樂", "公民", "幼保", "美術", "物理", "地科", "生物", "國文"], // 自定義標籤
    datasets: [
      {
        label: 'Color Distribution',
        backgroundColor: [
          '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FFCD56', '#C9CBCF'
        ],
        hoverBackgroundColor: [
          '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FFCD56', '#C9CBCF'
        ],
        data: [300, 50, 100, 200, 150, 120, 180, 90], // 相應的數據
      },
    ],
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ width: '45%', textAlign: 'center' }}>
        <br></br><h2>能力統計</h2>
        <Bar data={BarChartData} options={barChartOptions} />
      </div>
      <div style={{ width: '35%', textAlign: 'center' }}>
        <br></br><h2>任教科目分佈</h2>
        <Doughnut data={DoughnutData} />
      </div>
    </div>
  );
};

export default CombinedCharts;
